import { Star, Quote } from "lucide-react";

export default function ReviewCard({ review, index = 0 }) {
  return (
    <div className="h-full rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-testid={`review-card-${index}`}>
      <div className="flex items-center justify-between">
        <div className="flex">
          {Array.from({ length: review.stars || 5 }).map((_, i) => (
            <Star key={i} className="h-4 w-4 text-amber-500 fill-amber-500" />
          ))}
        </div>
        <Quote className="h-5 w-5 text-pink-200" />
      </div>
      <p className="mt-3 text-slate-800 leading-relaxed">“{review.quote}”</p>
      <div className="mt-4 flex items-center justify-between text-sm">
        <span className="font-semibold text-slate-900">{review.name}</span>
        <span className="text-slate-500">{review.device}</span>
      </div>
    </div>
  );
}
